/**
 * Lightweight SVG spinner. A muted track with a rotating accent arc — no
 * GIFs, no dependencies. Pair with an optional inline label for "Loading
 * members…" style states. Honors prefers-reduced-motion (see CSS).
 */

import './Spinner.css';

interface Props {
  /** Diameter in px. Defaults to 16 (inline size). */
  size?: number;
  /** Optional label shown next to the spinner and used as the a11y name. */
  label?: string;
  className?: string;
}

export function Spinner({ size = 16, label, className }: Props): JSX.Element {
  return (
    <span className={'spinner-wrap' + (className ? ` ${className}` : '')}>
      <svg
        className="spinner"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        role="status"
        aria-label={label ?? 'Loading'}
      >
        <circle className="spinner-track" cx="12" cy="12" r="9" fill="none" strokeWidth="3" />
        <circle
          className="spinner-head"
          cx="12"
          cy="12"
          r="9"
          fill="none"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
      {label && <span className="spinner-label">{label}</span>}
    </span>
  );
}
